import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconSelect from '../../Icons/IconSelect';
import classNames from '../../utils/dom-utils';

class Dropdown extends Component {
  constructor(props) {
    super(props);
    const items = props.items || [];
    const value = props.value || '';
    const preSelectedValue = items.includes(value);
    this.state = {
      value: preSelectedValue ? value : '',
      showList: false,
      keyboardSelectionIndex: preSelectedValue
        ? items.findIndex(() => value)
        : 0,
    };
    this.elementRefs = items.map(() => React.createRef());
    this.listRef = React.createRef();
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (
      this.wrapperRef
            && !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({ showList: false });
    }
  }

  handleSelect(event) {
    this.selectOption(event.target.textContent);
  }

  handleShowList() {
    const { showList, value } = this.state;
    const { items } = this.props;
    const preSelectedValue = items.includes(value);
    this.setState(
      {
        showList: !showList,
        keyboardSelectionIndex: preSelectedValue
          ? items.findIndex(() => value)
          : 0,
      },
      () => {
        if (this.state.showList) {
          this.elementRefs[
            this.state.keyboardSelectionIndex
          ].current.focus();
        }
      },
    );
  }

  handleKeyDown(event) {
    const { key } = event;
    const moveSelection = (movement) => {
      if (!this.state.showList) this.handleShowList();
      const { items } = this.props;
      const { keyboardSelectionIndex } = this.state;

      event.preventDefault();
      const newKeyboardSelectionIndex = keyboardSelectionIndex + movement < items.length
                && keyboardSelectionIndex + movement >= 0
        ? keyboardSelectionIndex + movement
        : keyboardSelectionIndex;

      this.setState(
        {
          keyboardSelectionIndex: newKeyboardSelectionIndex,
        },
        () => this.elementRefs[
          this.state.keyboardSelectionIndex
        ].current.focus(),
      );
    };
    const options = {
      ArrowDown: () => moveSelection(1),
      ArrowUp: () => moveSelection(-1),
      Enter: () => this.selectOption(
        this.props.items[this.state.keyboardSelectionIndex],
      ),
    };
    if (options[key]) {
      options[key].call(this);
    }
  }

  selectOption(value) {
    this.setState({ value, showList: false });
    this.props.onChange(value);
  }

  render() {
    const {
      items = [],
      errorType = 'none',
      placeholder = 'Select a category',
      title = '',
      darkTheme = true,
    } = this.props;
    const { showList, value } = this.state;
    const baseContainerClass = 'c-dropdown-container';
    const baseClass = 'c-dropdown';
    const baseTitleClass = 'c-dropdown__title';
    const baseListClass = 'c-dropdown__list';
    const baseElementClass = 'c-dropdown__element';

    let showPlaceholder = false;
    let displayValue = value;
    if (value === '') {
      showPlaceholder = true;
      displayValue = placeholder;
    }

    const rootClass = classNames(baseClass, {
      [`${baseClass}--${errorType}`]: errorType,
      [`${baseClass}--dark-mode`]: darkTheme,
      [`${baseClass}--empty`]: showPlaceholder,
    });

    const rootTitleClass = classNames(baseTitleClass, {
      [`${baseTitleClass}--dark-mode`]: darkTheme,
    });

    const rootListClass = classNames(baseListClass, {
      [`${baseListClass}--dark-mode`]: darkTheme,
    });

    const listItems = items.map((item, index) => {
      const { keyboardSelectionIndex } = this.state;
      return (
        <li
          tabIndex={index}
          onClick={this.handleSelect.bind(this)}
          role="option"
          aria-selected={keyboardSelectionIndex === index}
          key={item}
          className={baseElementClass}
          ref={this.elementRefs[index]}
        >
          {item}
        </li>
      );
    });

    return (
      <div
        ref={this.wrapperRef}
        className={baseContainerClass}
        onKeyDown={this.handleKeyDown.bind(this)}
      >
        {title && <div className={rootTitleClass}>{title}</div>}
        <button
          type="button"
          className={rootClass}
          onClick={this.handleShowList.bind(this)}
        >
          {displayValue}
          <IconSelect />
        </button>
        {showList && (
        <ul ref={this.listRef} className={rootListClass}>
          {listItems}
        </ul>
        )}
      </div>
    );
  }
}

Dropdown.propTypes = {
  placeholder: PropTypes.string,
  title: PropTypes.string,
  darkTheme: PropTypes.bool,
  items: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
  errorType: PropTypes.string,
};

export default Dropdown;
